import { c as _c } from "react/compiler-runtime";
import { Avatar } from '@systemeio/components';
import type { ReactNode } from 'react';
import { MENU_POPUP_SECTION_CLASS_NAME, MOBILE_NAVBAR_ITEM_PADDING_CLASS_NAME } from 'shared/components/navbar/constants';
import { twJoin } from 'tailwind-merge';
interface SelectorItemProps {
  displayName: string;
  isOption?: boolean;
  src?: string | null;
}
export function SelectorItem(t0) {
  const $ = _c(11);
  const {
    displayName,
    isOption: t1,
    src
  } = t0;
  const isOption = t1 === undefined ? false : t1;
  const t2 = src ?? undefined;
  let t3;
  if ($[0] !== displayName || $[1] !== t2) {
    t3 = <Avatar size="md" src={t2} displayName={displayName} />;
    $[0] = displayName;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isOption ? "line-clamp-2 wrap-break-word" : "truncate";
  let t5;
  if ($[3] !== t4) {
    t5 = twJoin("min-w-0", t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== displayName || $[6] !== t5) {
    t6 = <span className={t5}>{displayName}</span>;
    $[5] = displayName;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t6) {
    t7 = <div className="[&_svg]:text-icon-on flex min-w-0 items-center gap-1.5">{t3}{t6}</div>;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}
export const selectorTriggerClassName = 'border-field-border data-popup-open:border-field-border-active transition-base transition-colors flex w-full min-w-0 items-center justify-between gap-1.5 rounded-md border px-2 py-1.5 data-popup-open:[&>svg]:rotate-180';

// Sized like the Select droplist (trigger width, 160px minimum) instead of the Menu's fit-content,
// so a long account name wraps and clamps rather than widening the popup.
export const selectorPopupClassName = 'tablet:max-h-79 tablet:w-(--anchor-width) tablet:min-w-40';
interface SelectorFieldProps {
  action?: ReactNode;
  children: ReactNode;
  isDesktop: boolean;
  label: string;
}

/**
 * Labelled wrapper around an account selector, optionally with an action next to the label.
 * Carries the padding of its surface: a popup section on desktop, a side-menu row on mobile.
 */
export function SelectorField(t0) {
  const $ = _c(11);
  const {
    action,
    children,
    isDesktop,
    label
  } = t0;
  const t1 = isDesktop ? MENU_POPUP_SECTION_CLASS_NAME : MOBILE_NAVBAR_ITEM_PADDING_CLASS_NAME;
  let t2;
  if ($[0] !== t1) {
    t2 = twJoin("flex min-w-0 flex-col gap-2", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <span className="text-text-secondary min-w-0 truncate">{label}</span>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== action || $[5] !== t3) {
    t4 = <div className="flex min-w-0 items-center gap-1">{t3}{action}</div>;
    $[4] = action;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== t2 || $[9] !== t4) {
    t5 = <div className={t2}>{t4}{children}</div>;
    $[7] = children;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}